import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { IncidentDetailPatient } from '../useIncidentDetailForHiroshima';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { convertToPresenceAbsence } from 'core/components/common/converters';
import { FC } from 'react';

type Props = {
  findingsEmsTeamContact: IncidentDetailPatient['findingsEmsContact'];
};

export const FindingsEmsTeamContactView: FC<Props> = ({
  findingsEmsTeamContact,
}) => (
  <BorderedContainer>
    <div className="flex flex-col gap-[24px]">
      <SectionTitle text="身体所見" />
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="吐気"
          content={convertToPresenceAbsence(
            findingsEmsTeamContact.reveals.hasNausea
          )}
        />
        <InfoDisplay
          title="嘔吐"
          content={convertToPresenceAbsence(
            findingsEmsTeamContact.reveals.hasVomiting
          )}
        />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="出血"
          content={convertToPresenceAbsence(
            findingsEmsTeamContact.reveals.hasBleedingType
          )}
        />
        <InfoDisplay
          title="出血量"
          content={findingsEmsTeamContact.reveals.bleedingValue}
        />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="失禁"
          content={findingsEmsTeamContact.reveals.incontinence}
        />
      </div>
    </div>
  </BorderedContainer>
);
